<style scoped>
  .order-tracking-filter {
    padding-left: 0px;
  }
</style>
<template>
    <div class="row">
        <div class="col-lg-4 offset-lg-4 col-md-6 offset-md-3 col-sm-8 offset-sm-2 g-my-20">
            <div class="input-group mb-3">
                <input v-model="searchValueC" value="" v-on:keyup="EmptySearch()" v-bind:disabled="isDataLoading" v-on:keyup.enter="SearchTable()" type="text" class="form-control" placeholder="Search.." >
                <div class="input-group-append">
                    <button v-on:click="SearchTable()" v-bind:disabled="isDataLoading" class="btn g-color-white u-btn-primary" type="button">Search <span><i class="fa fa-search"></i></span></button>
                </div>
            </div>
        </div>
        <div v-if="elementConfig.orderTrackingStatusShow  || MasterAccountType == 'master'" class="col-lg-12 col-lg-12 col-sm-12 col-sm-12">
           <div class="row">
                <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 text-center">
                    <div class="form-group">
                        <h5 class="g-py-10">Filter by Date Range</h5>
                        <div class="row">
                            <div class="col-lg-5 col-md-12 col-sm-5 col-xs-12">
                                <div class="row g-px-10">
                                    <div class="input-group">
                                        <datepicker :disabled-picker="isDataLoading" v-model="dateFrom" :bootstrap-styling="true" :format="format" name="uniquename" :calendar-button="true" calendar-button-icon="fa fa-calendar"></datepicker>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-2 col-md-2 col-sm-1 col-xs-12 center">
                                <p>To</p>
                            </div>
                            <div class="col-lg-5 col-md-12 col-sm-5 col-xs-12">
                                <div class="row g-px-10">
                                    <div class="form-group">
                                        <datepicker :disabled-picker="isDataLoading" v-model="dateTo" :disabled="datepickerState.disabled" :bootstrap-styling="true" :format="format" @closed="SearchTable()" name="uniquename" :calendar-button="true" calendar-button-icon="fa fa-calendar"></datepicker>
                                    </div>
                                </div>
                            </div>
                            <!-- <div class="col-lg-1 col-md-1 col-sm-1 col-xs-1">
                                <p style="background-color: yellow; font-size: 25px; color: "><i class="fa fa-calendar"></i></p>
                            </div> -->
                        </div>

                    </div>
                </div>
                <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 text-center">
                    <div class="form-group">
                        <h5 class="g-py-10">Filter by Status</h5>
                        <div class="row">
                            <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                <div class="form-check form-check-inline">
                                    <input v-bind:disabled="isDataLoading" v-model="statusFilterC" v-on:click="FilterToString('Pending')" class="form-check-input" type="checkbox" value="Pending">
                                    <label class="form-check-label order-tracking-filter">Pending</label>
                                </div>
                                <div class="form-check form-check-inline">
                                    <input v-bind:disabled="isDataLoading" v-model="statusFilterC" v-on:click="FilterToString('PendingError')" class="form-check-input" type="checkbox" value="PendingError" >
                                    <label class="form-check-label order-tracking-filter">Pending - Error</label>
                                </div>
                            </div>
                            <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                <div class="form-check form-check-inline">
                                    <input v-bind:disabled="isDataLoading" v-model="statusFilterC" v-on:click="FilterToString('PendingApproval')" class="form-check-input" type="checkbox" value="PendingApproval">
                                    <label class="form-check-label order-tracking-filter">Pending Approval</label>
                                </div>
                                <div class="form-check form-check-inline">
                                    <input v-bind:disabled="isDataLoading" v-model="statusFilterC" v-on:click="FilterToString('InProcess')" class="form-check-input" type="checkbox" value="InProcess" >
                                    <label class="form-check-label order-tracking-filter">In Process</label>
                                </div>
                                <div class="form-check form-check-inline">
                                    <input v-bind:disabled="isDataLoading" v-model="statusFilterC" v-on:click="FilterToString('Shipped')" class="form-check-input" type="checkbox" value="Shipped">
                                    <label class="form-check-label order-tracking-filter">Shipped</label>
                                </div>
                            </div>
                            <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                <div class="form-check form-check-inline">
                                    <input v-bind:disabled="isDataLoading" v-model="statusFilterC" v-on:click="FilterToString('Dispensed')" class="form-check-input" type="checkbox" value="Dispensed">
                                    <label class="form-check-label order-tracking-filter">Dispensed</label>
                                </div>
                                <div class="form-check form-check-inline">
                                    <input v-bind:disabled="isDataLoading" v-model="statusFilterC" v-on:click="FilterToString('Cancelled')" class="form-check-input" type="checkbox" value="Cancelled">
                                    <label class="form-check-label order-tracking-filter">Cancelled</label>
                                </div>
                                <div class="form-check form-check-inline">
                                    <input v-bind:disabled="isDataLoading" v-model="statusFilterC" v-on:click="FilterToString('ExamOnly')" class="form-check-input" type="checkbox" value="ExamOnly" >
                                    <label class="form-check-label order-tracking-filter">Exam Only</label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="text-center track-order-btns" :class="[{'loading':isDataLoading}, {'btn-pos-if-empty':OrderList.length == 0}]">
                    <button v-bind:disabled="isDataLoading" v-on:click="MarkAsDispensed()" class="btn g-color-white g-bg-main g-bg-main-blue--hover g-rounded-10 g-px-20">Mark selected as dispensed</button>
                    <button v-bind:disabled="isDataLoading" v-on:click="Reset()" class="btn g-color-white g-bg-main g-bg-main-blue--hover g-rounded-10 g-px-20">Reset Filters</button>
                    <button v-bind:disabled="isDataLoading" v-on:click="ExportToExcel()" class="btn g-color-white g-bg-main g-bg-main-blue--hover g-rounded-10 g-px-20">Export file with current filters</button>
                </div>
           </div>
        </div>
        <div v-else class="col-md-6 offset-md-3">
            <div class="row">
                <div class="col-lg-9 col-md-9 col-sm-12 col-xs-12 text-center">
                    <div class="form-group">
                        <h5 class="g-py-10">Filter by Date Range</h5>
                        <div class="row">
                            <div class="col-lg-5 col-md-12 col-sm-5 col-xs-12">
                                <div class="row g-px-10">
                                    <div class="input-group">
                                        <datepicker :disabled-picker="isDataLoading" v-model="dateFrom" :bootstrap-styling="true" :format="format" name="uniquename" :calendar-button="true" calendar-button-icon="fa fa-calendar"></datepicker>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-2 col-md-2 col-sm-1 col-xs-12 center">
                                <p>To</p>
                            </div>
                            <div class="col-lg-5 col-md-12 col-sm-5 col-xs-12">
                                <div class="row g-px-10">
                                    <div class="form-group">
                                        <datepicker :disabled-picker="isDataLoading" v-model="dateTo" :disabled="datepickerState.disabled" :bootstrap-styling="true" :format="format" @closed="SearchTable()" name="uniquename" :calendar-button="true" calendar-button-icon="fa fa-calendar"></datepicker>
                                    </div>
                                </div>
                            </div>
                            <!-- <div class="col-lg-1 col-md-1 col-sm-1 col-xs-1">
                                <p style="background-color: yellow; font-size: 25px; color: "><i class="fa fa-calendar"></i></p>
                            </div> -->
                        </div>

                    </div>
                </div>
                <div class="col-lg-3 col-md-3 col-sm-12 col-xs-12 text-center">
                    <button v-on:click="Reset()" class="btn g-color-white g-bg-main g-bg-main-blue--hover g-rounded-10 g-my-50 g-px-20">Reset Filters</button>
                </div>
            </div>
        </div>
        <div v-show="!isDataLoading" class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
            <pagination ref="pagination" :records="PageValues.totalList" :per-page="PageValues.itemsPerPage" :theme='theme' :chunk='chunk' @paginate="setPage" count-text="{from} to {to} of {count} records|{count} records|1 record"></pagination>
        </div>



        <div v-show="markDispenseModal">
            <div class="modal-mask" role="dialog">
                <div class="overlay-mask">
                    <div class="modal-dialog">
                        <div class="modal-content g-mt-170">
                            <div class="modal-body">
                                <div class="my-account-title">{{ !isDispensed ? 'Mark as Dispensed': 'Successfully Dispensed'}}</div>
                                <div class="row g-my-20 g-mx-20 " v-show="!isDispensed">
                                    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 g-my-15">
                                        <label>Enter Dispense Date:</label>
                                        <datepicker :disabled-picker="isDataLoading" v-model="dateDispense" :bootstrap-styling="true" :format="format" name="uniquename" :calendar-button="true" calendar-button-icon="fa fa-calendar"></datepicker>
                                    </div>
                                    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 center">
                                            <button class="btn g-color-white g-bg-main g-bg-info--hover g-rounded-10 g-btn-130 g-mx-10 g-font-size-15" v-on:click="SaveMarkForDispense()">Mark Dispensed</button>
                                        <div>
                                            <small>This will mark {{listToMarkDispense.length}} orders as dispensed. This cannot be undone in bulk, but individual orders can be marked as Not Dispensed on the Order Confirmation page.</small>
                                        </div>

                                        <button class="btn g-color-white g-bg-main g-bg-primary--hover g-rounded-10 g-btn-130 g-mx-10 g-font-size-15" v-on:click="markDispenseModalClose()">Cancel</button>
                                    </div>
                                </div>
                                <div class="row g-my-20 g-mx-20 " v-show="isDispensed">
                                    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 g-my-15">
                                        Record(s) have been marked as "Dispensed"
                                    </div>
                                    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 center">
                                        <button class="btn g-color-white g-bg-main g-bg-primary--hover g-rounded-10 g-btn-130 g-mx-10 g-font-size-15" v-on:click="markDispenseModalClose()">Close</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>


    </div>
</template>
<script>
    import {Pagination} from 'vue-pagination-2';
    import Datepicker from 'vuejs-datepicker';
    import FileSaver from 'file-saver';
    export default {
        components: {Datepicker, Pagination},
        props:['OrderList', 'DispenseList', 'SearchObject', 'PageValues', 'isDataLoading', 'searchValue', 'statusFilter', 'statusString'],
        data(){
            return{
               markDispenseModal:false,
               isDispensed: false,
               listToMarkDispense:[],
               dateDispense:null,
               theme:'bootstrap4',
               chunk:5,
               searchValueC:this.searchValue,
               format:'MM/dd/yyyy',
               dateFrom:null,
               dateTo:null,
               statusFilterC:this.statusFilter,
               statusStringC:this.statusString,
            //    status:['Pending', 'PendingApproval', 'InProcess', 'Shipped', 'Dispensed' , 'Cancelled', 'PendingError', 'ExamOnly'],
            //    statusString:'Pending|PendingApproval|InProcess|Shipped|Cancelled|PendingError|ExamOnly',
            //    dummyStatus:['Pending', 'PendingApproval', 'InProcess', 'Shipped', 'Dispensed' , 'Cancelled', 'PendingError', 'ExamOnly'],
               isFirstLoad:true,
               MasterAccountType:null
            }
        },
        watch:{
            searchValueC: function(newValue){
                this.$emit('update:searchValue', newValue)
            },
            statusFilterC: function(newValue){
                this.$emit('update:statusFilter', newValue)
            },
            statusStringC: function(newValue){
                this.$emit('update:statusString', newValue)
            }
        },
        computed:{
            datepickerState: function() {
                var disabledDate =  {
                                        disabled: {
                                            to: this.dateFrom
                                        }
                                    }
                return  disabledDate;
            },
            computedIsLoading: {
              get: function() {
                this.isDataLoading;
              },
              set: function(newValue) {
                this.isDataLoading = newValue;
              }
            }
        },
        methods: {
            markDispenseModalClose(){
                this.markDispenseModal = false;
                if (this.isDispensed) {
                    this.isDispensed = false;
                    this.$router.go();
                }
            },
            setPage(page) {
                this.PageValues.currentPage = page;
                this.$emit("clicked");
            },
            SearchTable(){
                this.PageValues.currentPage = 1;
                this.SearchObject[0].RefinerValue= this.searchValueC;
                if(this.dateFrom != null && this.dateTo != null){
                    this.SearchObject[1].RefinerValue= this.dateFrom + "|" + this.dateTo;
                }
                this.SearchObject[2].RefinerValue = this.statusStringC;
                this.$refs.pagination.setPage(1);//calls the set page function
            },
            EmptySearch(){
                if(this.searchValueC.length == 0 || this.searchValueC == null){
                    this.SearchTable();
                }
            },
            MarkAsDispensed(){
                // check if there is dispense = true but not shipped
                let hasForMarking = false;
                let confirmDispensed = false;
                let dispenseAlert = false;
                let noDispenseList = [];
                let noDispenseText = "";
                for (let index = 0; index < this.DispenseList.length; index++) {
                    if(this.DispenseList[index].dispense == true){
                        hasForMarking = true
                        if(this.DispenseList[index].orderStatus != "shipped" && this.DispenseList[index].orderStatus != "Shipped"){
                            noDispenseList.push(this.DispenseList[index])
                            noDispenseText = noDispenseText + `${this.DispenseList[index].patFirstName} ${this.DispenseList[index].patLastName} : ${this.DispenseList[index].orderStatus} \n`
                            dispenseAlert = true
                        }
                    }
                }
                if(hasForMarking == false){
                    alert("Please select order to dispense.")
                    return
                } 
                
                let list = []
                this.listToMarkDispense = []
                if(this.DispenseList && this.DispenseList.length > 0){
                    list = this.DispenseList.filter(e=>((e.orderStatus == "shipped" || e.orderStatus == "Shipped") && e.dispense == true))
                }
                list.forEach(e => {
                    this.listToMarkDispense.push({id:e.id, date:null})
                });

                if(this.listToMarkDispense.length == 0){
                    alert("Please select \"Shipped\" order to be marked as dispensed.")
                    this.markDispenseModal = false
                    return    
                }

                if(dispenseAlert == true){
                    confirmDispensed = confirm(`Please note, the following order(s) are not yet shipped and will not be marked as dispensed. \n\n ${noDispenseText}`)
                    if(confirmDispensed){
                        this.markDispenseModal = true
                    }
                } else{
                    this.markDispenseModal = true
                }


            },
            SaveMarkForDispense(){
                
                this.isDataLoading = true;
                this.listToMarkDispense.forEach(e => {
                    e.date = this.dateDispense
                });

                var _this = this;
                axios.post('/Order/MarkDispensed', this.listToMarkDispense, { headers: { 'Authorization': "Bearer " + localStorage.getItem("token") }, responseType: 'blob' })
                .then((response) => {
                    // alert(`${response.data.raw.length} records was marked dispensed.`)
                    _this.isDispensed = true;
                    _this.isDataLoading = false;
                    _this.listToMarkDispense = []
                    // alert(`Records has been marked as dispensed.`)
                    // /Portal/OrderTracking
                    // _this.$router.push({name: 'OrderTracking'});
                })
                .catch(function(error) {
                    console.log(error);
                    _this.markDispenseModal = false;
                    _this.isDataLoading = false;
                    _this.listToMarkDispense = []
                    // _this.$router.push({name: 'Error'});
                });
            },
            Reset(){
                this.searchValueC = '';
                this.dateFrom = null;
                this.dateTo = null;
                // this.status =['Pending', 'PendingApproval', 'InProcess', 'Shipped', 'Dispensed' , 'Cancelled', 'PendingError', 'ExamOnly'];
                this.statusStringC='Pending|PendingApproval|InProcess|Shipped|Dispensed|Cancelled|PendingError|ExamOnly';
                this.statusFilterC=[
                    "Pending",
                    "PendingApproval",
                    "InProcess",
                    "Shipped",
                    "Dispensed",
                    "Cancelled",
                    "PendingError",
                    "ExamOnly"
                ]
                this.statusFilter=['Pending', 'PendingApproval', 'InProcess', 'Shipped', 'Dispensed' ,'Cancelled', 'PendingError', 'ExamOnly'];
                this.$emit("reset");
            },
            ExportToExcel(){
                var _this = this;
                _this.isDataLoading = true;
                var searchObject = Array.from(_this.SearchObject);
                searchObject.push({ RefinerType: 'Count', RefinerValue: _this.PageValues.totalList});
                axios.post('/Order/ExportToExcel', searchObject, { headers: { 'Authorization': "Bearer " + localStorage.getItem("token") }, responseType: 'blob' })
                .then(function(response) {

                    var blob = new Blob([response.data],{type: 'text/csv' });
                    FileSaver.saveAs(blob, "OrderTrackingList.csv");

                    _this.isDataLoading = false;
                })
                .catch(function(error) {
                    console.log(error);
                    _this.$router.push({name: 'Error'});
                });
            },
            FilterToString(value){
                var index = this.statusFilterC.findIndex(x => x == value);
                if(index != -1){
                    this.statusFilterC.splice(index, 1);
                }else{
                    this.statusFilterC.push(value)
                }
                var find = ',';
                var re = new RegExp(find, 'g');
                this.statusStringC = this.statusFilterC.toString().replace(re, '|');
                console.log("this.statusFilterC")
                console.log(this.statusFilterC)
                console.log("this.statusStringC")
                console.log(this.statusStringC)
                this.SearchTable();
            }
        },
        created(){
            this.MasterAccountType = localStorage.getItem("accountType");
            // let find = ',';
            // let re = new RegExp(find, 'g');
            // this.statusString = this.statusFilter.toString().replace(re, '|');
            this.statusFilterC = [...this.statusFilter]
            this.statusStringC = this.statusString
            console.log("this.statusFilterC")
            console.log(this.statusFilterC)
            console.log("this.statusStringC")
            console.log(this.statusStringC)
            this.dateDispense = new Date();
        }
    }
</script>




// WEBPACK FOOTER //
// OrderTrackingFilters.vue?4098f724